module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-footer center no-print"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row m-t-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(typeof _vm.$store.state.user.data !== 'undefined') ? _c('ul', {
    staticClass: "footerLinks"
  }, [(_vm.$store.state.user.data.type === 'promoter') ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/' + _vm.language + '/supplier/terms'
    }
  }, [_vm._v(_vm._s(_vm.t('General Terms of Service')))])], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.language === 'pt') ? _c('a', {
    attrs: {
      "href": _vm.apiPublicUrl + 'docs/MANGOPAY_TERMS__PI_EN.pdf',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.t('Framework Contract of the Payment Processing Entity')))]) : _vm._e(), _vm._v(" "), (_vm.language === 'en') ? _c('a', {
    attrs: {
      "href": _vm.apiPublicUrl + 'docs/MANGOPAY_TERMS__PI_EN.pdf',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.t('Framework Contract of the Payment Processing Entity')))]) : _vm._e()]), _vm._v(" "), (typeof _vm.$store.state.user.data !== 'undefined') ? _c('li', [(_vm.$store.state.user.data.type !== 'promoter') ? _c('router-link', {
    attrs: {
      "to": ("/" + _vm.language + "/terms")
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('Terms of Use')) + "\n            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (typeof _vm.$store.state.user.data !== 'undefined') ? _c('li', [(_vm.$store.state.user.data.type !== 'promoter') ? _c('router-link', {
    attrs: {
      "to": ("/" + _vm.language + "/privacy-policy")
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('Privacy Policy')) + "\n            ")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "footerLinks"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.language + "/supplier")
    }
  }, [_vm._v(_vm._s(_vm.t('I want to be a partner')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.language + "/faq")
    }
  }, [_vm._v(_vm._s(_vm.t('FAQ')))])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.language + "/about-us")
    }
  }, [_vm._v(_vm._s(_vm.t('About Us')))])], 1)]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid copyright"
  }, [_vm._v("\n    © " + _vm._s(_vm.year) + " "), _c('a', {
    attrs: {
      "href": "http://www.booknatura.com"
    }
  }, [_vm._v(" booknatura.com ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('address', [_c('p', [_vm._v("Rua Cerca das Cabanas, lote 3B")]), _vm._v(" "), _c('p', [_vm._v("7645-247 Vila Nova de Milfontes")]), _vm._v(" "), _c('p', [_vm._v("Telefone: +351 936 326 295")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://blog.booknatura.com",
      "target": "_blank"
    }
  }, [_vm._v("Blog")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:info@booknatura.com"
    }
  }, [_vm._v("info@booknatura.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-xs-right logos"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/booknaturapt/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/fb.svg",
      "height": "16",
      "alt": "Facebook Logo"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/booknatura/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/instagram.svg",
      "height": "16",
      "alt": "Facebook Logo"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/booknatura",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/twitter.svg",
      "height": "16",
      "alt": "Twitter Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support row m-t-3 m-b-4"
  }, [_c('div', {
    staticClass: "col-md-6 logoCol"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/barra_cofin_FEDER.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 logoCol"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/barra_cofin_FSE.svg"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1473bf5b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1473bf5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBlock/FooterBlock.vue
// module id = 761
// module chunks = 3